/* global G */
import clean from 'app/_shared/hook/action/clean'
import noHistory from 'app/_shared/hook/action/noHistory'
import appBarBack from 'app/_shared/hook/appbar/back'
import create from 'app/_shared/hook/appbar/create'
import multiCreate from 'app/_shared/hook/appbar/multiCreate'
import quickActions from 'app/_shared/hook/appbar/quickActions'
import check from 'app/_shared/hook/check'
import recall from 'app/_shared/hook/component/recall'
import clear from 'app/_shared/hook/model/clear'
import mapAttribute from 'app/_shared/hook/model/mapAttribute'
import updateCache from 'app/_shared/hook/model/updateCache'
import onlineCheck from 'app/_shared/hook/onlineCheck'
import platform from 'app/_shared/hook/platform'
import stepper from 'app/_shared/hook/stepper'
import recent from 'app/recent/hook/recent'
import uiTitle from 'app/request/hook/uiTitle'
import ticketQuickActions from 'app/ticket/hook/quickActions'
import bulk from 'lib/hook/model/bulk'
import read from 'lib/hook/model/read'
import action, { currentAction } from 'lib/hook/module/action'
import confirm from 'lib/hook/router/confirm'
import { confirmation } from 'lib/hook/transaction'
import ui from 'lib/hook/ui/update'
import { setKey } from 'lib/util'
import submitInitialAttachmentMessage from './hook/submitInitialAttachmentMessage'
import redirect from 'lib/hook/router/redirect'

const _baseHooks = {
  before: [],
  after: [
    ui,
  ],
}

const _readHooks = {
  before: [
    read,
  ],
  after: [
    ui,
  ],
}

const _indexHooks = {
  before: [
    platform({
      web: [create],
      mobile: [multiCreate],
    }),
    recall,
  ],
  after: [
    ui,
  ],
}

const _locationHooks = {
  before: [
    mapAttribute('itemInstalledAt'),
  ],
  after: [
    ui,
    confirm,
  ],
}

const _createHooks = {
  before: [
    onlineCheck(),
    // Clears the module error, so that we can still use redirect to navigate the drawer actions.
    // Should be replaced by using force redirect
    obj => async (...args) => {
      setKey(null, G.ERROR, obj[G.STATE])
      return args
    },
    platform({
      mobile: [
        appBarBack,
        quickActions,
      ],
    }),
  ],
  after: [
    stepper,
    ui,
    confirm,
  ],
}

const _bulkHooks = {
  before: [
    // validate, // seq validate
  ],
  after: [
    ui, // show validation errors, if exist
    bulk, // seq create/update, getValue, transform, post/put
    // submitFirstMessage, // not needed, server handles this.
    // submitAttachments, // handled by submitInitialAttachmentMessage
    // redirect, // same as above
    clean,
    noHistory,
    submitInitialAttachmentMessage,
    redirect,
    updateCache,
  ],
}

const _submitFavoriteHooks = {
  before: [],
  after: [
    ui,
    check,
    confirmation('favorite', 'success'),
    action('successFavorite'),
  ],
}

const _successFavoriteHooks = {
  before: [],
  after: [
    currentAction,
  ],
}

const _detailHooks = {
  before: [
    clear,
    read,
    platform({
      mobile: quickActions,
    }),
  ],
  after: [
    ticketQuickActions,
    uiTitle,
    ui,
    // confirm,
    recent,
  ],
}

const hooks = {
  [G.ACTIONS]: {
    index: _indexHooks,
    create: _createHooks,
    location: _locationHooks,
    bulk: _bulkHooks,
    created: _readHooks,
    detail: _detailHooks,
    description: _readHooks,
    reopenRequest: _readHooks,
    attachments: _baseHooks,
    messageOptions: _baseHooks,
    showAttachments: _baseHooks,

    submitFavorite: _submitFavoriteHooks,
    successFavorite: _successFavoriteHooks,
  },
}

export default hooks
